var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideo = function SvgVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M3.281 9.188H17.72v7.218a.656.656 0 0 1-.657.657H3.938a.656.656 0 0 1-.656-.657zM3.281 9.188l13.946-3.741-.681-2.535a.65.65 0 0 0-.804-.46L3.068 5.85a.656.656 0 0 0-.468.804zM10.672 3.806l4.02 2.322M4.971 5.34l4.011 2.322"
  })));
};
export default SvgVideo;